<template>
  <a-modal
    :title="title"
    :width="1250"
    :visible="visible"
    @ok="
      () => {
        $emit('ok')
      }
    "
    @cancel="
      () => {
        $emit('cancel')
      }
    "
  >
    <a-spin :spinning="loading">
      <a-form :form="form" v-bind="formLayout">
        <a-row>
          <a-row>
            <a-col :span="12">
              <a-form-item label="网络模型类型">
                <a-select
                  placeholder="请选择网络模型类型"
                  v-decorator="['networkModelTypeId', { rules: [{ required: true, message: '请选择网络模型类型' }] }]">
                  <a-select-option v-for="p in networkModelTypeList" :key="p.id" :value="p.id">
                    {{ p.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-col :span="12">
            <a-form-item label="资源库">
              <a-select
                mode="multiple"
                placeholder="请选择资源库"
                v-decorator="['pathIds', { rules: [{ required: true, message: '请选择资源库' }] }]"
              >
                <a-select-option v-for="p in resourceList" :key="p.id" :value="p.id">
                  {{ p.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="训练次数">
              <a-input v-decorator="['trainFrequency', { rules: [{ required: true, message: '请输入训练次数' }] }]" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-item label="cbatch_size">
              <a-input v-decorator="['cbatchSize']" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="clr">
              <a-input v-decorator="['clr']" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-item label="image_height">
              <a-input v-decorator="['imageHeight']" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="image_width">
              <a-input v-decorator="['imageWidth']" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-item label="decay_frequency">
              <a-input v-decorator="['decayFrequency']" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="decay_factor">
              <a-input v-decorator="['decayFactor']" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-item label="brightness_factor_start">
              <a-input v-decorator="['brightnessFactorStart']" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="brightness_factor_end">
              <a-input v-decorator="['brightnessFactorEnd']" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-item label="add_factor_start"> <a-input v-decorator="['addFactorStart']" /> </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="add_factor_end">
              <a-input v-decorator="['addFactorEnd']" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-item label="hue_val_start">
              <a-input v-decorator="['hueValStart']" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="hue_val_end">
              <a-input v-decorator="['hueValEnd']" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-item label="translate_ptx_start">
              <a-input v-decorator="['translatePtxStart']" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="translate_ptx_end">
              <a-input v-decorator="['translatePtxEnd']" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-item label="translate_pty_start">
              <a-input v-decorator="['translatePtyStart']" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="translate_pty_end"> <a-input v-decorator="['translatePtyEnd']" /> </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-item label="rotation_angle_start">
              <a-input v-decorator="['rotationAngleStart']" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="rotation_angle_end">
              <a-input v-decorator="['rotationAngleEnd']" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-item label="rotation_scale_start">
              <a-input v-decorator="['rotationScaleStart']" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="rotation_scale_end">
              <a-input v-decorator="['rotationScaleEnd']" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-item label="contrast_factor_start">
              <a-input v-decorator="['contrastFactorStart']" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="contrast_factor_end">
              <a-input v-decorator="['contrastFactorEnd']" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-item label="use_gray">
              <a-input v-decorator="['useGray']" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="pool_rate">
              <a-input v-decorator="['poolRate']" />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import pick from 'lodash.pick'
import { requestUrl } from '@/utils/request_url'
import * as networkmodel from '@/api/networkmodel_management'
import * as networkmodeltype from '@/api/networkmodeltype_management'
const fields = [
  // 'networkModelId',
  'networkModelTypeId',
  'pathIds',
  'trainFrequency',
  'cbatchSize',
  'clr',
  'imageHeight',
  'imageWidth',
  'decayFrequency',
  'decayFactor',
  'brightnessFactorStart',
  'brightnessFactorEnd',
  'addFactorStart',
  'addFactorEnd',
  'saturationFactorStart',
  'saturationFactorEnd',
  'hueValStart',
  'hueValEnd',
  'translatePtxStart',
  'translatePtxEnd',
  'translatePtyStart',
  'translatePtyEnd',
  'rotationAngleStart',
  'rotationAngleEnd',
  'rotationScaleStart',
  'rotationScaleEnd',
  'contrastFactorStart',
  'contrastFactorEnd',
  'useGray',
  'poolRate',
]
export default {
  name: 'TrainConfig_classify',
  props: {
    loading: {
      type: Boolean,
      default: () => false,
    },
    model: {
      type: Object,
      default: () => null,
    },
    title: {
      type: String,
      default: '新增',
    },
    visible: {
      type: Boolean,
      required: true,
    },
    // networkModelList: {
    //   type: Array,
    //   default: () => null,
    // },
    networkModelTypeList: {
      type: Array,
      default: () => null,
    },
    resourceList: {
      type: Array,
      default: () => null,
    },
  },
  data() {
    this.formLayout = {
      labelCol: {
        xs: { span: 6 },
        sm: { span: 7 },
      },
      wrapperCol: {
        xs: { span: 6 },
        sm: { span: 13 },
      },
    }
    return {
      form: this.$form.createForm(this),
      headers: {},
    }
  },
  created() {
    this.$watch('model', () => {
      this.model && this.form.setFieldsValue(pick(this.model, fields))
    })
  },
  // watch: {
  //   imageUrl: function (val) {
  //     debugger
  //   },
  // },
  computed: {},
  mounted() {
    //this.loadNetworkModel()
  },
  methods: {
    // loadNetworkModel() {},
  },
}
</script>
